import { EntityTypeEnum } from "../../enums/entity-type-id-enum";
import { FileUploadModel } from "./file-upload-model";

export class EntityFileUploadModel extends FileUploadModel {
    entityId?: string
    entityTypeId?: EntityTypeEnum;
}
